import * as _ from 'lodash';

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class BrandShopService {
    private priceBannerClosed = new BehaviorSubject(false);
    public readonly priceBannerClosedObservable = this.priceBannerClosed.asObservable();

    public setPriceBannerClosed(value: boolean) {
        this.priceBannerClosed.next(value);
    }
}
